var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":"Vocab"}},[_c('visual-vocab',{attrs:{"model":_vm.blast.vocabQuestion,"respondable":_vm.blast.isOpen || _vm.blast.isPreview}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66c71182","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/vocab.vue
// module id = null
// module chunks = 